import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader-component',
  standalone: false,
  templateUrl: './loader-component.html',
  styleUrl: './loader-component.css',
})
export class LoaderComponent {
  @Input() loading = false;
  @Input() message = 'Loading...';
}

